export default "__VITE_ASSET__UC$w1Pu2__"